<div class="snack-container flex items-center justify-between">
  <div class="flex items-center">
    <span>{{ data.message }}</span>
  </div>
  <div class="custom-toast-button-wrapper">
    <button (click)="close()" class="cursor-pointer">OK</button>
  </div>
</div>
